<template>
  <div class="body_box" v-if="detail.id">
    <h1 class="title">{{detail.title}}</h1>
    <div class="card-foot">发布日期：{{detail.submitTime}}&nbsp;&nbsp;&nbsp;&nbsp;类别：{{detail.categoryName}}</div>
    <div class="content" v-html="detail.postContent"></div>
  </div>
  <div v-else>
    <img src="../assets/nodata.png" class="nodata_img" />
    <div class="nodata_notice">资讯找不到了!</div>
  </div>
</template>

<script>
import Vue from "vue";
import { Icon } from "vant";
Vue.use(Icon);
import { Notify } from "vant";
import { queryPostDetail } from "@/api/user.js";
export default {
  data() {
    return {
      detail: {}
    };
  },
  created() {
    var id = this.$route.query.id ? this.$route.query.id : "";
    this.queryPostDetail(id);
  },
  methods: {
    queryPostDetail(id) {
      queryPostDetail(id).then((res) => {
        if (res.data.status == 200) {
          this.detail = res.data.object;
        } else {
          // Notify({ type: "danger", message: res.data.msg });
        }
      });
    }
  },
};
</script>

<style scoped >
.nodata_img {
  width: 3.2rem;
  height: 3.2rem;
}
.nodata_notice {
  font-size: 0.28rem;
}
.body_box {
  padding: 0.25rem;
  text-align: left;
}

.title {
  font-size: 0.35rem;
  text-align: center;
}

.content {
  font-size: 0.25rem;
  padding-top: 0.1rem;
  padding-bottom: 20px;
}

/deep/ .content > p {
  margin: 0;
  padding: 0;
}

.card-foot {
  text-align: center;
  font-size: 0.23rem;
  color: #939393;
  position: relative;
  top: -0.15rem;
}

</style>